<template>
  <div>
    <el-container>
      <!-- 编辑页面的侧边导航栏 -->
      <navMenu></navMenu>
      <el-main>
      <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import navMenu from "@/components/navMenu/navMenu.vue"
export default {
  components:{
    navMenu
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
  }
};
</script>
<style lang= "less" scoped>
</style>